
/**
 * Base or global document types
 */
const base = [
  {
    id: 'US1',
    name: 'Invoice',
    country: null,
    tax: 0,
    hasLinesTotal: false,
    partialCreditNotes: true
  },
  {
    id: 'US6',
    name: 'Recibo',
    country: null,
    tax: 0,
    hasLinesTotal: false,
    partialCreditNotes: true
  }
]

const baseCreditNotes = [
  {
    id: 'US2',
    name: 'Credit note',
    country: null,
    tax: 0,
    hasLinesTotal: false
  }
]

const baseDebitNotes = [
  {
    id: 'US3',
    name: 'Debit note',
    country: null,
    tax: 0,
    hasLinesTotal: false
  }
]

/**
 * Brazilean document types & miscellaneous
 */
const br = [
  {
    id: 'BR85',
    name: 'Nota fiscal de servicio',
    country: 'BR',
    tax: 18,
    hasLinesTotal: true,
    partialCreditNotes: false
  }
]

const brCreditNotes = [
  {
    id: 'BR88',
    name: 'Nota de crédito',
    country: 'BR',
    tax: 18,
    hasLinesTotal: true
  }
]

/**
 * Chilean document types & miscellaneous
 */
const cl = [
  {
    id: 'CL33',
    name: 'Factura electrónica',
    country: 'CL',
    tax: 19,
    hasLinesTotal: false,
    partialCreditNotes: true
  },
  {
    id: 'CL34',
    name: 'Factura exenta electrónica',
    country: 'CL',
    tax: 0,
    hasLinesTotal: false,
    partialCreditNotes: true
  },
  {
    id: 'CL39',
    name: 'Boleta electrónica',
    country: 'CL',
    tax: 19,
    hasLinesTotal: true,
    partialCreditNotes: true
  },
  {
    id: 'CL41',
    name: 'Boleta exenta electrónica',
    country: 'CL',
    tax: 0,
    hasLinesTotal: false,
    partialCreditNotes: true
  },
  {
    id: 'CL110',
    name: 'Factura de exportación',
    country: 'CL',
    tax: 0,
    hasLinesTotal: false,
    partialCreditNotes: true
  }
]

const clCreditNotes = [
  { id: 'CL61', name: 'Nota de crédito electrónica', country: 'CL', tax: 19, hasLinesTotal: false }
]

const clDebitNotes = [
  { id: 'CL56', name: 'Nota de débito electrónica', country: 'CL', tax: 19, hasLinesTotal: false }
]

const clPaymentTypes = [
  { id: '1', name: 'Contado' },
  { id: '2', name: 'Crédito' },
  { id: '3', name: 'Sin costo' }
]

const clReferences = [
  { id: 'CL801', name: 'Orden de compra', isNumeric: false },
  { id: 'CL802', name: 'Nota de pedido', isNumeric: false },
  { id: 'CL803', name: 'Contrato', isNumeric: false },
  { id: 'CLCT', name: 'Cotización', isNumeric: false },
  { id: 'CLHES', name: 'HES', isNumeric: false },
  { id: 'CLOT', name: 'Orden de trabajo', isNumeric: false },
  { id: 'CLSEN', name: 'SEN', isNumeric: false }
]

/**
 * Colombian document types & miscellaneous
 */
const co = [
  {
    id: 'CO01',
    allowPartialCredit: true,
    allowRetention: true,
    country: 'CO',
    isForeign: false,
    isOrder: false,
    isPurchase: false,
    isSale: true,
    name: 'Factura de venta nacional',
    hasLinesTotal: true,
    hasTaxes: true,
    hasTaxesDetail: true,
    partialCreditNotes: true,
    tax: 16
  }
]

const coPaymentMethods = [
  { id: 'undefined', name: 'Intrumento no definido' },
  { id: 'ach_credit', name: 'ACH Crédito' },
  { id: 'ach_debit', name: 'ACH Débito' },
  { id: 'cash', name: 'Efectivo' },
  { id: 'check', name: 'Cheque' },
  { id: 'credit_transfer', name: 'Transferencia de crédito' },
  { id: 'debit_transfer', name: 'Transferencia de débito' },
  { id: 'credit_card', name: 'Tarjeta de crédito' },
  { id: 'debit_card', name: 'Tarjeta de débito' }
]

const coPaymentForms = [
  { id: 'debit', name: 'Débito' },
  { id: 'credit', name: 'Crédito' }
]

/**
 * Mexican document types & miscellaneous
 */
const mx = [
  {
    id: 'MX20',
    name: 'Factura de ingreso',
    country: 'MX',
    tax: 16,
    hasLinesTotal: false,
    partialCreditNotes: false
  }
]

const mxCfdiUses = [
  { id: 'G01', name: 'Adquisición de mercancías' },
  { id: 'G02', name: 'Devoluciones, descuentos o bonificaciones' },
  { id: 'G03', name: 'Gastos en general' },
  { id: 'I01', name: 'Construcciones' },
  { id: 'I02', name: 'Mobiliario y equipo de oficina por inversiones' },
  { id: 'I03', name: 'Equipo de transporte' },
  { id: 'I04', name: 'Equipo de computo y accesorios' },
  { id: 'I05', name: 'Dados, troqueles, moldes, matrices y herramental' },
  { id: 'I06', name: 'Comunicaciones telefónicas' },
  { id: 'I07', name: 'Comunicaciones satelitales' },
  { id: 'I08', name: 'Otra maquinaria y equipo' },
  { id: 'D01', name: 'Honorarios médicos, dentales y gastos hospitalarios' },
  { id: 'D02', name: 'Gastos médicos por incapacidad o discapacidad' },
  { id: 'D03', name: 'Gastos funerales' },
  { id: 'D04', name: 'Donativos' },
  { id: 'D05', name: 'Intereses reales efectivamente pagados por créditos hipotecarios (casa habitación)' },
  { id: 'D06', name: 'Aportaciones voluntarias al SAR' },
  { id: 'D07', name: 'Primas por seguros de gastos médicos' },
  { id: 'D08', name: 'Gastos de transportación escolar obligatoria' },
  { id: 'D09', name: 'Depósitos en cuentas para el ahorro, primas que tengan como base planes de pensiones' },
  { id: 'D10', name: 'Pagos por servicios educativos (colegiaturas)' },
  { id: 'S01', name: 'Sin efectos fiscales' },
  { id: 'CP01', name:	'Pagos' },
  { id: 'CN01', name:	'Nómina' }
]

const mxPaymentForms = [
  { id: '01', name: 'Efectivo' },
  { id: '02', name: 'Cheque nominativo' },
  { id: '03', name: 'Transferencia electrónica de fondos' },
  { id: '04', name: 'Tarjeta de crédito' },
  { id: '05', name: 'Monedero electrónico' },
  { id: '06', name: 'Dinero electrónico' },
  { id: '08', name: 'Vales de despensa' },
  { id: '12', name: 'Dación en pago' },
  { id: '13', name: 'Pago por subrogación' },
  { id: '14', name: 'Pago por consignación' },
  { id: '15', name: 'Condonación' },
  { id: '17', name: 'Compensación' },
  { id: '23', name: 'Novación' },
  { id: '24', name: 'Confusión' },
  { id: '25', name: 'Remisión de deuda' },
  { id: '26', name: 'Prescripción o caducidad' },
  { id: '27', name: 'A satisfacción del acreedor' },
  { id: '28', name: 'Tarjeta de débito' },
  { id: '29', name: 'Tarjeta de servicios' },
  { id: '30', name: 'Aplicación de anticipos' },
  { id: '31', name: 'Intermediario pagos' },
  { id: '99', name: 'Por definir' }
]

const mxTaxRegime = [
  { id: '601', name: 'General de Ley Personas Morales' },
  { id: '603', name: 'Personas Morales con Fines no Lucrativos' },
  { id: '605', name: 'Sueldos y Salarios e Ingresos Asimilados a Salarios' },
  { id: '606', name: 'Arrendamiento' },
  { id: '608', name: 'Demás ingresos' },
  { id: '609', name: 'Consolidación' },
  { id: '610', name: 'Residentes en el Extranjero sin Establecimiento Permanente en México' },
  { id: '611', name: 'Ingresos por Dividendos (socios y accionistas)' },
  { id: '612', name: 'Personas Físicas con Actividades Empresariales y Profesionales' },
  { id: '614', name: 'Ingresos por intereses' },
  { id: '616', name: 'Sin obligaciones fiscales' },
  { id: '620', name: 'Sociedades Cooperativas de Producción que optan por diferir sus ingresos' },
  { id: '621', name: 'Incorporación Fiscal' },
  { id: '622', name: 'Actividades Agrícolas, Ganaderas, Silvícolas y Pesqueras' },
  { id: '623', name: 'Opcional para Grupos de Sociedades' },
  { id: '624', name: 'Coordinados' },
  { id: '628', name: 'Hidrocarburos' },
  { id: '607', name: 'Régimen de Enajenación o Adquisición de Bienes' },
  { id: '629', name: 'De los Regímenes Fiscales Preferentes y de las Empresas Multinacionales' },
  { id: '630', name: 'Enajenación de acciones en bolsa de valores' },
  { id: '615', name: 'Régimen de los ingresos por obtención de premios' },
  { id: '625', name: 'Régimen de las Actividades Empresariales con ingresos a través de Plataformas Tecnológicas' },
  { id: '626', name: 'Régimen Simplificado de Confianza' }
]

const documentTypes = base.concat(
  base,
  baseCreditNotes,
  baseDebitNotes,
  br,
  brCreditNotes,
  cl,
  clCreditNotes,
  clDebitNotes,
  mx
)

const invoiceTypes = base.concat(br, cl, co, mx)

const globalInvoiceTypes = ['US1', 'US6', 'CL110']

const creditNoteTypes = []

const debitNoteTypes = []

export {
  documentTypes,
  invoiceTypes,
  globalInvoiceTypes,
  creditNoteTypes,
  debitNoteTypes,
  clPaymentTypes,
  clReferences,
  coPaymentForms,
  coPaymentMethods,
  mxCfdiUses,
  mxPaymentForms,
  mxTaxRegime
}